import { Link } from "react-router-dom";
import { Button, useTheme } from "@monolith-forensics/monolith-ui";

// Details-page state for a failed (non-404) GET /assets/:uuid — 500, network
// error, revoked permission. Kept distinct from LabAssetNotFound so a
// transient failure never claims the asset was deleted. Same panel shape as
// LabAssetNotFound; onRetry is the context's refetch.
export const LabAssetLoadError: React.FC<{ onRetry: () => void }> = ({
  onRetry,
}) => {
  const theme = useTheme();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 15,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 5,
        width: "fit-content",
        margin: "auto",
        marginTop: 100,
      }}
    >
      <div style={{ fontSize: 24, fontWeight: "bold" }}>
        Something went wrong loading this asset.
      </div>
      <div style={{ color: theme.palette.text.secondary, fontSize: 18 }}>
        The asset may still exist — retry, or return to the assets list.
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
        <Button variant="contained" color="primary" size="xs" onClick={onRetry}>
          Retry
        </Button>
        <Link to="/assets">
          <Button variant="outlined" color="primary" size="xs">
            Return To Assets List
          </Button>
        </Link>
      </div>
    </div>
  );
};
